const defaultConfig= {
    appTokenKey:"sj_mall_admin_token", // 集运token key
    mallAppTokenKey:"mall_app_user_key", // 商城token key
    isTbPurchaseOrderMode:"isTbPurchaseOrderMode", // 是否是淘宝采购1688订单
    layoutCommonConfig:{  // 商城配置
        header:{ 
            url:"layout-header",
        },
        footer:{
            url:"layout-footer",   
        }
    },
    // layoutCommonConfig:{
    //     header:{
    //         url:"site-layout-header",
    //     },
    //     footer:{
    //         url:"site-layout-footer",   
    //     }
    // },
    devErpBuySite:false,// 开启erp采购调试
    proxyLinks:{
        collectionSite:"tmallsitehost:7788",
        frontServerSite:"frontserverhost:7788",
        mallSite:"jyshoprelink:8081",
        qiankunSite:"pc-qiankun-site:7788",
        // collectionSite:"http://xjhy.shopmember-test.omszt.com:7888",
        // mallSite:"http://api-test.jyshop.omszt.com:8081",
        // qiankunSite:"http://xjhy.shopmember-test.omszt.com:7888",
       





        // collectionSite:"MPS-gateway-1:8897",
        // mallSite:"jyshoprelink:8081",
        // qiankunSite:"pc-qiankun-site:7788",

    }
} 
export default defaultConfig;